import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/effect-fade";
import "swiper/css/effect-cube";

// import required modules
import {
  Autoplay,
  Pagination,
  EffectFade,
  Navigation,
  EffectCreative,
} from "swiper/modules";

import {
  collectionData,
  productsData,
  reviewsData,
  sliderData,
  sliderData2,
  sliderData3,
  staticBannerImageArr,
  testimonialData,
} from "../../helper/staticData";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import useBreakPoints from "../../hooks/useBreakPoints";
import Countdown from "react-countdown";
import moment from "moment";
import { MyContext } from "../../hooks/useContextProvider";
import Login from "../Authentication/Login";
import Testimonials from "./Testimonials";

const Home = () => {
  const navigate = useNavigate();
  const { token, callCartDetails, cartList, callWishListApi, wishList } =
    useContext(MyContext);

    let { referralCode } = useParams();
  const { isLaptop, isMobile, isTablet } = useBreakPoints();
  const [selectedCategory, setSelectedCategory] = useState("bestseller");
  const [selectedCollection, setSelectedCollection] = useState([]);
  const [allMainCategories, setAllMainCategories] = useState([]);
  const [brandLogo, setBrandLogo] = useState([]);
  const [bannerList, setBannerList] = useState({});
  const [advertiseBannerList, setAdvertiseBannerList] = useState([]);
  const [featuredProduct, setFreaturedProduct] = useState([]);
  const [topSellingProduct, setTopSellingProduct] = useState([]);
  const [topRatedProductList, setTopRatedProduct] = useState([]);
  const [loginModal, setLoginModal] = useState((referralCode !== "" && referralCode) ? true : false);
  const [sliderData, setSliderData] = useState([]);
  const [loading, setloading] = useState(false);
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef2 = useRef(null);
  const [currentTime, setCurrentTime] = useState(Date.now());

  // Effect to update current time every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (swiperRef2.current && swiperRef2.current.swiper) {
      swiperRef2.current.swiper.params.navigation.prevEl = prevRef.current;
      swiperRef2.current.swiper.params.navigation.nextEl = nextRef.current;
      swiperRef2.current.swiper.navigation.init();
      swiperRef2.current.swiper.navigation.update();
    }
  }, []);
  useEffect(() => {
    if (swiperRef?.current) {
      new Swiper(swiperRef.current, {
        slidesPerView: 4,
        spaceBetween: 0,
        loop: true,
        navigation: true,
        pagination: { clickable: true },
      });
    }
  }, [swiperRef]);

  useEffect(() => {
    AOS.init({ once: false, duration: 1000 }); // Initialize AOS with custom options
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      if (selectedCategory === "featuredProducts") {
        setSelectedCollection(featuredProduct);
      } else if (selectedCategory === "bestseller") {
        setSelectedCollection(topSellingProduct);
      } else if (selectedCategory === "topRated") {
        setSelectedCollection(topRatedProductList);
      }
    }
  }, [
    selectedCategory,
    featuredProduct,
    topSellingProduct,
    topRatedProductList,
  ]);


  const getAllProductListApi = () => {
    const token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}featuredproducts?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/logout");
          // window.location.reload();
        }
        if (data && data.status) {
          console.log("data: ", data);
          //  setAllProductData(data["productList"]);
          setSliderData(
            data?.imageSliderList.sort((a, b) => +a.order - +b.order)
          );
          setBannerList(data?.bannerList?.[0]);
          setAdvertiseBannerList(data?.advertiseBannerList);
          setBrandLogo(data?.brandsList);
          setFreaturedProduct(data?.featuredProductList);
          setTopSellingProduct(data?.topSellingProductList);
          setTopRatedProduct(data?.topRatedProductList);
          getAllMainCategoriesDetails();
        } else if (data.message !== "Invalid token") {
          setloading(false);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const getAllMainCategoriesDetails = async () => {
    console.log("running");

    const token = localStorage.getItem("token");
    const ipAddress = localStorage.getItem("ipaddress");

    await fetch(
      `${process.env.REACT_APP_API_URL}maincategorieslist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,

          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setAllMainCategories(data?.mainCategoryDetails);
          setloading(false);
        } else if (data.message !== "Invalid token") {
          setloading(false);
        }
      })
      .catch((error) => {
        toast.error("There was an error, Please try again later.");
      });
  };

  useEffect(() => {
    getAllProductListApi();
  }, []);

  const handleCartBtn = (productDetails) => {
    if (!token) {
      setLoginModal(true);
    } else {
      const selectedVariant = productDetails?.variants.reduce((min, variant) =>
        parseInt(variant.price) < parseInt(min.price) ? variant : min
      );

      setloading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("productId", productDetails?.id);
      formData.append(
        "productAttributeId",
        selectedVariant?.attributeDetails?.id
      );
      formData.append("productVariantId", selectedVariant?.id);
      formData.append("qty", 1);
      formData.append("created_by", "");
      formData.append("updated_by", "");
      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addcart?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/logout");
            // window.location.reload();
          }
          if (data && data.status) {
            setloading(false);
            callCartDetails();
          }
          setloading(false);
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };
  const handleWhishListBtn = (productDetails) => {
    if (!token) {
      setLoginModal(true);
    } else {
      setloading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("productId", productDetails?.id);
      formData.append("created_by", "");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addwishlist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/logout");
          }
          if (data && data.status) {
            setloading(false);
            callWishListApi();
          }
          setloading(false);
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  return (
    <div id="main" style={{ marginTop: 0 }}>
      <div class="wdt-elementor-container-fluid cust-header">
        <div
          data-elementor-type="wp-page"
          data-elementor-id="191"
          class="elementor elementor-191"
        >
          {/* Main Page Slider Start  */}
          <section
            class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-64e31e0 wdt-h1-slider-section elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="64e31e0"
            data-element_type="section"
            data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div class="elementor-background-overlay"></div>
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8e96d66"
                data-id="8e96d66"
                data-element_type="column"
                data-settings='{"background_background":"classic"}'
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-85af1e8 elementor-widget__width-initial elementor-absolute elementor-widget elementor-widget-image"
                    data-id="85af1e8"
                    data-element_type="widget"
                    data-settings='{"_position":"absolute","wdt_animation_effect":"none"}'
                    data-widget_type="image.default"
                  >
                    <div class="elementor-widget-container">
                      <img
                        fetchpriority="high"
                        decoding="async"
                        width="244"
                        height="400"
                        src="https://furniforma.wpengine.com/wp-content/uploads/2024/09/furniforma-about-filler-img1.png"
                        class="attachment-full size-full wp-image-164"
                        alt=""
                        srcset="https://furniforma.wpengine.com/wp-content/uploads/2024/09/furniforma-about-filler-img1.png 244w, https://furniforma.wpengine.com/wp-content/uploads/2024/09/furniforma-about-filler-img1-183x300.png 183w"
                        sizes="(max-width: 244px) 100vw, 244px"
                      />{" "}
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-ce7ec4b elementor-widget__width-initial elementor-widget-mobile_extra__width-inherit elementor-absolute wdt-cus-slider-01-spacer elementor-widget elementor-widget-spacer"
                    data-id="ce7ec4b"
                    data-element_type="widget"
                    data-settings='{"_position":"absolute","wdt_animation_effect":"none"}'
                    data-widget_type="spacer.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="elementor-spacer">
                        <div class="elementor-spacer-inner"></div>
                      </div>
                    </div>
                  </div>
                  <section
                    class="custom-slider-home-2 elementor-section elementor-inner-section elementor-element elementor-element-71bada9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="71bada9"
                    data-element_type="section"
                    data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                  >
                    <div class="elementor-container elementor-column-gap-no">
                      <div
                        class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-b3bab89"
                        data-id="b3bab89"
                        data-element_type="column"
                      >
                        <div class="elementor-widget-wrap elementor-element-populated">
                          <div
                            class="elementor-element elementor-element-3d7bfce wdt-cus-home-1-main-slider-01 center elementor-widget elementor-widget-wdt-advanced-carousel"
                            data-id="3d7bfce"
                            data-element_type="widget"
                            data-settings='{"slides_to_show_opts":"1","slides_to_show_opts_laptop":"1","slides_to_show_opts_tablet_extra":"1","slides_to_show_opts_tablet":"1","pagination":"custom","effect":"fade","speed":1000,"gap":{"unit":"dpt","size":0,"sizes":[]},"direction":"horizontal","slides_to_show_opts_mobile_extra":1,"slides_to_show_opts_mobile":1,"slides_to_scroll_opts":"single","mouse_wheel_scroll":"false","gap_laptop":{"unit":"px","size":"","sizes":[]},"gap_tablet_extra":{"unit":"px","size":"","sizes":[]},"gap_tablet":{"unit":"px","size":"","sizes":[]},"gap_mobile_extra":{"unit":"px","size":"","sizes":[]},"gap_mobile":{"unit":"px","size":"","sizes":[]},"allow_touch":"yes","loop":"yes","centered_slides":"no","item_align":"center","carousel_arrows_prev_arrow_vertical_align":"flex-start","carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_align":"flex-start","carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                            data-widget_type="wdt-advanced-carousel.default"
                          >
                            <div class="elementor-widget-container  mt-60">
                              <div
                                class="wdt-advanced-carousel-holder  wdt-content-item-holder wdt-carousel-holder wdt-rc-template-default"
                                id="wdt-advanced-carousel-3d7bfce"
                                data-id="3d7bfce"
                                data-settings=""
                              >
                                <Swiper
                                  grabCursor={true}
                                  loop
                                  autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                  }}
                                  modules={[Autoplay]}
                                  className="mySwiper wdt-advanced-carousel-wrapper swiper-wrapper"
                                >
                                  {sliderData?.map((item, i) => {
                                    return (
                                      <SwiperSlide>
                                        <div
                                          class="wdt-content-item"
                                          data-aos="fade-up"
                                          data-aos-delay=""
                                        >
                                          <div
                                            data-elementor-type="page"
                                            data-elementor-id="262"
                                            class="elementor elementor-262"
                                          >
                                            <section
                                              class="elementor-section elementor-top-section elementor-element elementor-element-75066b6 elementor-section-full_width elementor-section-height-min-height elementor-section-items-stretch elementor-section-height-default"
                                              data-id="75066b6"
                                              data-element_type="section"
                                              data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                                            >
                                              <div class="elementor-container elementor-column-gap-no">
                                                <div
                                                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c006a7b"
                                                  data-id="c006a7b"
                                                  data-element_type="column"
                                                >
                                                  <div class="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                      class="elementor-element elementor-element-152de85 start wdt-cus-home-1-slide-heading-01 wdt-cus-font-size-h1 wdt-cus-subtitle-icon before-title elementor-widget elementor-widget-wdt-heading"
                                                      data-id="152de85"
                                                      data-element_type="widget"
                                                      data-settings='{"item_align":"start","header_decorative_elements_icon_align":"before-title","split_heading":"false","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                                                      data-widget_type="wdt-heading.default"
                                                    >
                                                      <div class="elementor-widget-container">
                                                        <div
                                                          class="wdt-heading-holder  wdt-heading-wrapper-start"
                                                          id="wdt-heading-152de85"
                                                        >
                                                          <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                                                            <span class="wdt-heading-subtitle">
                                                              <span class="wdt-heading-deco-inner wdt-left-part">
                                                                <span class="wdt-heading-deco-icon">
                                                                  <span class="wdt-content-icon-wrapper">
                                                                    <span class="wdt-content-icon">
                                                                      <span>
                                                                        <i>
                                                                          <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 100 100"
                                                                          >
                                                                            <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                                                          </svg>
                                                                        </i>
                                                                      </span>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                              </span>
                                                              {/* {item?.title} */}
                                                              Special Collection
                                                              <span class="wdt-heading-deco-inner wdt-right-part"></span>
                                                            </span>
                                                          </div>
                                                          <h2 class="wdt-heading-title-wrapper wdt-heading-align-center ">
                                                            <span
                                                              class="wdt-heading-title"
                                                              style={{
                                                                display:
                                                                  "contents",
                                                              }}
                                                            >
                                                              {item?.title}
                                                            </span>
                                                          </h2>
                                                          <div
                                                            class="wdt-heading-content-wrapper"
                                                            style={{
                                                              display:
                                                                "contents",
                                                              marginTop:
                                                                "-65px",
                                                            }}
                                                          >
                                                            {item?.buttonTitle}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="elementor-element elementor-element-e26aaa1 start wdt-cus-home-1-slide-btn elementor-widget elementor-widget-wdt-button"
                                                      data-id="e26aaa1"
                                                      data-element_type="widget"
                                                      data-settings='{"item_align":"start","wdt_animation_effect":"none"}'
                                                      data-widget_type="wdt-button.default"
                                                    >
                                                      <div class="elementor-widget-container">
                                                        <div
                                                          class="wdt-button-holder wdt-template-filled wdt-button-link wdt-button-style-default wdt-button-size-nm wdt-animation- wdt-button-icon-after"
                                                          id="wdt-button-e26aaa1"
                                                          style={{
                                                            opacity: 1,
                                                            display: "contents",
                                                          }}
                                                        >
                                                          <Link
                                                            class="wdt-button"
                                                            to={item?.path}
                                                          >
                                                            <div class="wdt-button-text">
                                                              <span>
                                                                View Our
                                                                Collection
                                                              </span>
                                                            </div>
                                                          </Link>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3882919"
                                                  data-id="3882919"
                                                  data-element_type="column"
                                                  data-settings='{"background_background":"classic"}'
                                                >
                                                  <div class="elementor-widget-wrap elementor-element-populated">
                                                    <div class="elementor-background-overlay"></div>
                                                    <div
                                                      class="elementor-element elementor-element-769b664 elementor-widget-mobile_extra__width-initial elementor-widget-mobile__width-inherit wdt-cus-home-1-slide-img-01 elementor-widget elementor-widget-image"
                                                      data-id="769b664"
                                                      data-element_type="widget"
                                                      data-settings='{"wdt_animation_effect":"none"}'
                                                      data-widget_type="image.default"
                                                    >
                                                      <div class="elementor-widget-container">
                                                        <img
                                                          data-aos="fade-up"
                                                          data-aos-delay=""
                                                          decoding="async"
                                                          width="900"
                                                          height="870"
                                                          src={
                                                            item?.sliderImage
                                                          }
                                                          class="attachment-full size-full wp-image-267"
                                                          alt=""
                                                          // srcset={`https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-img-01.png 900w, https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-img-01-300x290.png 300w, https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-img-01-768x742.png 768w`}
                                                          sizes="(max-width: 900px) 100vw, 900px"
                                                        />{" "}
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="elementor-element elementor-element-6cb05c5 elementor-widget__width-initial elementor-absolute wdt-cus-home-1-slide-text-path-01 elementor-widget elementor-widget-text-path"
                                                      data-id="6cb05c5"
                                                      data-element_type="widget"
                                                      data-settings='{"text":"We make the Ordinary, Extraordinary.","text_path_direction":"ltr","_position":"absolute","link":{"url":"","is_external":"","nofollow":"","custom_attributes":""},"start_point":{"unit":"%","size":0,"sizes":[]},"wdt_animation_effect":"none"}'
                                                      data-widget_type="text-path.default"
                                                    >
                                                      <div class="elementor-widget-container">
                                                        <div
                                                          class="e-text-path"
                                                          data-text="We make the Ordinary, Extraordinary."
                                                          data-url="//furniforma.wpengine.com/wp-content/plugins/elementor/assets/svg-paths/circle.svg"
                                                          data-link-url=""
                                                        >
                                                          <svg
                                                            viewBox="0 0 250.5 250.5"
                                                            height="250.5"
                                                            width="250.5"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              d="M.25,125.25a125,125,0,1,1,125,125,125,125,0,0,1-125-125"
                                                              id="e-path-6cb05c5"
                                                            ></path>
                                                            <text>
                                                              <textPath
                                                                id="e-text-path-6cb05c5"
                                                                href="#e-path-6cb05c5"
                                                                startOffset="0%"
                                                              >
                                                                We make the
                                                                Ordinary,
                                                                Extraordinary.
                                                              </textPath>
                                                            </text>
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="elementor-element elementor-element-48ef823 elementor-hidden-desktop elementor-hidden-laptop elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile elementor-widget elementor-widget-wdt-popup-box"
                                                      data-id="48ef823"
                                                      data-element_type="widget"
                                                      data-settings='{"show_close_Button":"true","esc_to_exit":"true","click_to_exit":"true","wdt_animation_effect":"none"}'
                                                      data-widget_type="wdt-popup-box.default"
                                                    >
                                                      <div class="elementor-widget-container">
                                                        <div
                                                          class="wdt-popup-box-trigger-holder wdt-click-element-external-id"
                                                          id="wdt-popup-box-trigger-48ef823"
                                                          data-settings='{"module_id":"48ef823","module_ref_id":"wdt-popup-box-48ef823","popup_class":"wdt-popup-box-window wdt-popup-box-window-48ef823 wdt-fade-zoom","trigger_type":"external-id","on_load_delay":null,"on_load_after":null,"external_class":null,"external_id":"#wdt-cus-home-1-slide-rotate-icon","show_close_Button":true,"esc_to_exit":true,"click_to_exit":true,"mfp_src":"https://vimeo.com/149015473","mfp_type":"iframe"}'
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </section>
                                          </div>
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Swiper>
                                {/* <div class="wdt-carousel-pagination-wrapper">
                                  <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal wdt-swiper-pagination wdt-swiper-pagination-3d7bfce swiper-pagination-custom swiper-pagination-horizontal">
                                    <span class="swiper-pagination-current">
                                      01
                                    </span>
                                    <span class="wdt-custom-slide wdt-active"></span>
                                    <span class="wdt-custom-slide "></span>
                                    <span class="wdt-custom-slide "></span>
                                    <span class="swiper-pagination-total">
                                      03
                                    </span>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>

          <section
            class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-c038898 elementor-section-full_width elementor-reverse-tablet elementor-reverse-mobile_extra elementor-reverse-mobile elementor-section-height-default elementor-section-height-default "
            data-id="c038898"
            data-element_type="section"
            style={{ marginTop: "-140px", background: "#faf7f2" }}
            data-settings='{"animation":"fadeInUp","animation_delay":200,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div class="elementor-background-overlay"></div>
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2a57de3"
                data-id="2a57de3"
                data-element_type="column"
                data-settings='{"background_background":"classic"}'
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-b796f69 start wdt-cus-home-1-slide-prdt-imgbox wdt-dark-bg center elementor-widget elementor-widget-wdt-image-box"
                    data-id="b796f69"
                    data-element_type="widget"
                    data-settings='{"item_align":"start","effect":"fade","slides_to_show_opts":"1","slides_to_show_opts_laptop":"1","slides_to_show_opts_tablet_extra":"1","slides_to_show_opts_tablet":"1","gap":{"unit":"dpt","size":"0","sizes":[]},"item_align_mobile":"center","direction":"horizontal","slides_to_show_opts_mobile_extra":1,"slides_to_show_opts_mobile":1,"slides_to_scroll_opts":"single","mouse_wheel_scroll":"false","pagination":"bullets","speed":300,"gap_laptop":{"unit":"px","size":"","sizes":[]},"gap_tablet_extra":{"unit":"px","size":"","sizes":[]},"gap_tablet":{"unit":"px","size":"","sizes":[]},"gap_mobile_extra":{"unit":"px","size":"","sizes":[]},"gap_mobile":{"unit":"px","size":"","sizes":[]},"allow_touch":"yes","overflow_opacity":"yes","carousel_arrows_prev_arrow_vertical_align":"flex-start","carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_align":"flex-start","carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                    data-widget_type="wdt-image-box.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-image-box-holder  wdt-content-item-holder wdt-carousel-holder wdt-rc-template-custom-template"
                        id="wdt-image-box-b796f69"
                        data-id="b796f69"
                        data-settings='{"enable_popup":"","enable_hover_class":""}'
                      >
                        {/* <div
                                class="wdt-image-box-container swiper"
                                data-settings='{"direction":"horizontal","effect":"fade","slides_to_show":"1","slides_to_scroll":1,"arrows":"","pagination":"bullets","mouse_wheel_scroll":"false","speed":300,"autoplay":"","autoplay_speed":null,"autoplay_direction":null,"allow_touch":"yes","loop":null,"centered_slides":null,"pause_on_interaction":null,"overflow_opacity":"yes","unequal_height_compatability":null,"gap":"0","responsive":[{"breakpoint":319,"toshow":1,"toscroll":1},{"breakpoint":480,"toshow":1,"toscroll":1},{"breakpoint":768,"toshow":1,"toscroll":1},{"breakpoint":1025,"toshow":1,"toscroll":1},{"breakpoint":1281,"toshow":1,"toscroll":1},{"breakpoint":1541,"toshow":1,"toscroll":1}],"space_between_gaps":{"desktop":"0","mobile":"0","mobile_extra":"0","tablet":"0","tablet_extra":"0","laptop":"0"}}'
                                id="wdt-image-box-swiper-b796f69"
                              > */}
                        <Swiper
                          grabCursor={true}
                          loop
                          autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                          }}
                          modules={[Autoplay]}
                          className="mySwiper wdt-image-box-container swiper custom-slider-home"
                        >
                          {featuredProduct?.map((item, i) => {
                            return (
                              <SwiperSlide>
                                <div
                                  class="wdt-content-item"
                                  style={{
                                    gridTemplateColumns: "repeat(2, 260px)",
                                  }}
                                >
                                  <div class="wdt-content-media-group">
                                    <div class="wdt-content-image-wrapper">
                                      <div class="wdt-content-image">
                                        <Link to="/" style={{ marginTop: 0 }}>
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            width="250"
                                            height="250"
                                            src={
                                              JSON.parse(
                                                item?.productGallery || "[]"
                                              )?.[0]
                                            }
                                            class="attachment-full size-full wp-image-278"
                                            alt=""
                                          />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="wdt-content-detail-group">
                                    {/* <div class="wdt-content-subtitle">
                                      {item?.title}
                                    </div> */}
                                    <div class="wdt-content-title">
                                      <h5>
                                        <Link
                                          to={`/product-details/${item?.id}`}
                                        >
                                          {" "}
                                          {item?.productName}
                                        </Link>
                                      </h5>
                                    </div>
                                    <div class="wdt-content-description">
                                      <p>
                                        {" "}
                                        {
                                          item?.variants?.length > 0 && item?.variants.reduce(
                                            (min, variant) =>
                                              parseInt(variant.price) <
                                                parseInt(min.price)
                                                ? variant
                                                : min
                                          )?.price
                                        }
                                      </p>
                                    </div>
                                    <div class="wdt-content-button wdt-button-clone">
                                      <Link to={`/product-details/${item?.id}`}>
                                        <div class="wdt-button-text">
                                          <span>Shop Now</span>
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                        {/* </div> */}
                        <div class="wdt-carousel-pagination-wrapper">
                          <div class="wdt-swiper-pagination wdt-swiper-pagination-b796f69"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-9ff406f elementor-widget__width-auto elementor-absolute elementor-hidden-mobile_extra elementor-hidden-mobile elementor-widget-tablet_extra__width-auto elementor-widget elementor-widget-image"
                    data-id="9ff406f"
                    data-element_type="widget"
                    data-settings='{"_position":"absolute","wdt_animation_effect":"none"}'
                    data-widget_type="image.default"
                  >
                    <div class="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width="150"
                        height="510"
                        src="https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-lamp-img.png"
                        class="attachment-full size-full wp-image-279"
                        alt=""
                        srcset="https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-lamp-img.png 150w, https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-lamp-img-88x300.png 88w"
                        sizes="(max-width: 150px) 100vw, 150px"
                      />{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a0808b0 wdt-overflow-hidden"
                data-id="a0808b0"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-0cd43e6 wdt-cus-home-1-slide-counter start center elementor-widget elementor-widget-wdt-counter"
                    data-id="0cd43e6"
                    data-element_type="widget"
                    data-settings='{"columns":"3","item_align":"start","columns_laptop":"3","columns_tablet_extra":"2","columns_tablet":"3","columns_mobile_extra":"2","item_align_mobile":"center","columns_mobile":1,"carousel_arrows_prev_arrow_vertical_align":"flex-start","carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_align":"flex-start","carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                    data-widget_type="wdt-counter.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-counter-holder wdt-content-item-holder wdt-column-holder wdt-rc-template-custom-template"
                        id="wdt-counter-0cd43e6"
                        data-settings=""
                      >
                        <div
                          class="wdt-column-wrapper wdt-column-gap-custom wdt-snap-scroll-enabled"
                          data-column-settings='{"columnDevices":["tablet_extra","mobile_extra","mobile"]}'
                          data-module-id="wdt-module-id-0cd43e6"
                          id="wdt-module-id-0cd43e6"
                        >
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-counter-wrapper">
                                  <div class="wdt-content-counter">
                                    <span
                                      class="wdt-content-counter-number"
                                      data-from="0"
                                      data-to="12"
                                      data-speed="1000"
                                      data-refresh-interval="100"
                                    ></span>
                                    <span class="wdt-content-counter-suffix">
                                      12 K
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-description">
                                  <p>Premium Furniture Built To Last</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-counter-wrapper">
                                  <div class="wdt-content-counter">
                                    <span
                                      class="wdt-content-counter-number"
                                      data-from="0"
                                      data-to="100"
                                      data-speed="1000"
                                      data-refresh-interval="100"
                                    ></span>
                                    <span class="wdt-content-counter-suffix">
                                      100 +
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-description">
                                  <p>Distinctive Aesthetic Designs</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-counter-wrapper">
                                  <div class="wdt-content-counter">
                                    <span
                                      class="wdt-content-counter-number"
                                      data-from="0"
                                      data-to="1"
                                      data-speed="1000"
                                      data-refresh-interval="100"
                                    ></span>
                                    <span class="wdt-content-counter-suffix">
                                      1 K+
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-description">
                                  <p>Delighted Customers Every Day</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="wdt-column-pagination wdt-snap-scroll-pagination">
                          <button class="wdt-pagination-prev wdt-module-id-0cd43e6">
                            Previous
                          </button>
                          <button class="wdt-pagination-next wdt-module-id-0cd43e6">
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Main Page Slider End  */}

          {/* Slider 2 */}
          <section
            class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-592e451 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="592e451"
            data-element_type="section"
            data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bb53369"
                data-id="bb53369"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-9467d4b start elementor-widget__width-initial before-title  elementor-widget elementor-widget-wdt-heading"
                    data-id="9467d4b"
                    data-element_type="widget"
                    data-settings='{"item_align":"start","_animation":"fadeInUp","_animation_delay":200,"split_heading":"true","wdt_enable_inview_status":"true","header_decorative_elements_icon_align":"before-title","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                    data-widget_type="wdt-heading.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-heading-holder  wdt-heading-wrapper-start"
                        id="wdt-heading-9467d4b"
                      >
                        <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span class="wdt-heading-subtitle">
                            <span class="wdt-heading-deco-inner wdt-left-part">
                              <span class="wdt-heading-deco-icon">
                                <span class="wdt-content-icon-wrapper">
                                  <span class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 100 100"
                                        >
                                          <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                            Shop Smart, Shop Sorted
                            <span class="wdt-heading-deco-inner wdt-right-part"></span>
                          </span>
                        </div>
                        <h2 class="wdt-heading-title-wrapper wdt-heading-align-center ">
                          <span class="wdt-heading-title">
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">D</span>
                              <span class="wdt-split-heading-title">i</span>
                              <span class="wdt-split-heading-title">s</span>
                              <span class="wdt-split-heading-title">c</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">v</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">r</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">B</span>
                              <span class="wdt-split-heading-title">y</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">C</span>
                              <span class="wdt-split-heading-title">a</span>
                              <span class="wdt-split-heading-title">t</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">g</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">y</span>
                            </span>
                          </span>
                        </h2>
                        <div class="wdt-heading-content-wrapper">
                          Explore a wide range of premium furniture, hardware accessories, kitchen fittings, 
                          bathroom essentials, tools, and interior solutions crafted for durability, functionality, and modern living.
                          vulputate{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-23214aa wdt-cus-category-listing-carousel  elementor-widget elementor-widget-wdt-shop-product-cat"
                    data-id="23214aa"
                    data-element_type="widget"
                    data-settings='{"slides_to_show_opts":"6","_animation":"fadeInUp","_animation_delay":300,"slides_to_show_opts_laptop":"5","slides_to_show_opts_tablet_extra":"4","slides_to_show_opts_tablet":"3","slides_to_show_opts_mobile_extra":"2","gap":{"unit":"dpt","size":30,"sizes":[]},"gap_laptop":{"unit":"px","size":30,"sizes":[]},"gap_tablet_extra":{"unit":"px","size":30,"sizes":[]},"gap_tablet":{"unit":"px","size":30,"sizes":[]},"gap_mobile_extra":{"unit":"px","size":20,"sizes":[]},"gap_mobile":{"unit":"px","size":20,"sizes":[]},"slides_to_show_opts_mobile":1,"wdt_animation_effect":"none"}'
                    data-widget_type="wdt-shop-product-cat.default"
                  >
                    <div class="elementor-widget-container">
                      <Swiper
                        grabCursor={true}
                        loop
                        slidesPerView={
                          isMobile ? 1 : isTablet ? 2 : isLaptop ? 3 : 6
                        }
                        spaceBetween={40}
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                        className="mySwiper wdt-advanced-carousel-wrapper swiper-wrapper wdt-taxonomy-swiper swiper-container"
                      >
                        {allMainCategories?.map((item, i) => {
                          return (
                            <SwiperSlide
                              key={i}
                              className="wdt-shop-category-listing-item swiper-slide first type2"
                            >
                              <div class="wdt-shop-category-listing-inner">
                                <div class="wdt-shop-category-listing-image">
                                  <Link
                                    to={"/shop"}
                                    state={{ mainCategory: item }}
                                  >
                                    <img
                                      decoding="async"
                                      src={item?.mainCategoryImage}
                                      alt="Category Image"
                                    />
                                  </Link>
                                </div>
                                <div class="wdt-shop-category-meta-data">
                                  <h3>
                                    <Link
                                      to={"/shop"}
                                      state={{ mainCategory: item }}
                                    >
                                      {item?.mainCategoryName}
                                    </Link>
                                  </h3>
                                  {/* <div class="wdt-shop-category-total-items">
                                    -<span>{item?.items}</span> Items-
                                  </div> */}
                                </div>
                              </div>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Image Section  */}
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-27e28f6 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="27e28f6"
            data-element_type="section"
            data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-13f99c5"
                data-id="13f99c5"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-d6c83bc wdt-cus-home-1-hotspot-style-01 elementor-widget elementor-widget-wdt-hotspot"
                    data-id="d6c83bc"
                    data-element_type="widget"
                    data-settings='{"tooltip_trigger":"click","wdt_animation_effect":"none"}'
                    data-widget_type="wdt-hotspot.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-hotspot-holder"
                        data-settings='{"tooltipPlacement":"top","tooltipTrigger":"click","tooltipAnimation":"fade","tooltipDelay":{"unit":"ms","size":0,"sizes":[]},"tooltipArrow":false,"tooltipResponsive":{"tooltip_trigger":{"mobile":"click","mobile_extra":"click","tablet":"click","tablet_extra":"click","laptop":"click","desktop":"click"}}}'
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="2560"
                          height="1270"
                          src="https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg.jpg"
                          class="attachment-full size-full wp-image-1724"
                          alt=""
                          srcset="https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg.jpg 2560w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg-300x149.jpg 300w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg-1024x508.jpg 1024w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg-768x381.jpg 768w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg-1536x762.jpg 1536w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg-2048x1016.jpg 2048w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Hostspot-banner-01-bg-1000x496.jpg 1000w"
                          sizes="(max-width: 2560px) 100vw, 2560px"
                        />
                        <div class="wdt-hotspot-items-holder">
                          <div
                            class="wdt-hotspot-repeater-item elementor-repeater-item-aa8c565 "
                            data-tooltip-position="left"
                            data-tooltip-image=""
                          >
                            <div class="wdt-hotspot-item-trigger wdt-hotspot-expand">
                              <div class="wdt-hotspot-item-icon">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-circle"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="wdt-hotspot-repeater-item elementor-repeater-item-d50834a "
                            data-tooltip-position="right"
                            data-tooltip-image=""
                          >
                            <div class="wdt-hotspot-item-trigger wdt-hotspot-expand">
                              <div class="wdt-hotspot-item-icon">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-circle"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="wdt-hotspot-repeater-item elementor-repeater-item-4a8e668 "
                            data-tooltip-position="left"
                            data-tooltip-image=""
                          >
                            <div class="wdt-hotspot-item-trigger wdt-hotspot-expand">
                              <div class="wdt-hotspot-item-icon">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-circle"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="wdt-hotspot-repeater-item elementor-repeater-item-6a0a7c4 "
                            data-tooltip-position="right"
                            data-tooltip-image=""
                          >
                            <div class="wdt-hotspot-item-trigger wdt-hotspot-expand">
                              <div class="wdt-hotspot-item-icon">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-circle"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          data-tippy-root=""
                          id="tippy-2"
                          style={{
                            zIndex: "9999",
                            visibility: "visible",
                          }}
                        >
                          <div
                            class="tippy-box"
                            data-state="visible"
                            tabindex="-1"
                            data-animation="fade"
                            role="tooltip"
                            style={{
                              maxWidth: "350px",
                              transitionDuration: "300ms",
                              position: "absolute",
                              top: 10,
                              left: 10,
                              width: isMobile
                                ? 150
                                : isTablet
                                  ? 180
                                  : isLaptop
                                    ? 200
                                    : 350,
                            }}
                            data-placement="right"
                            data-reference-hidden=""
                            data-escaped=""
                          >
                            <div
                              class="tippy-content"
                              data-state="visible"
                              style={{ transitionDuration: "300ms" }}
                            >
                              <div
                                data-elementor-type="page"
                                data-elementor-id="1727"
                                class="elementor elementor-1727"
                              >
                                <section
                                  class="elementor-section elementor-top-section elementor-element elementor-element-62aae8e elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                                  data-id="62aae8e"
                                  data-element_type="section"
                                >
                                  <div class="elementor-container elementor-column-gap-no">
                                    <div
                                      class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-77c1aa5"
                                      data-id="77c1aa5"
                                      data-element_type="column"
                                    >
                                      <div class="elementor-widget-wrap elementor-element-populated">
                                        <div
                                          class="elementor-element elementor-element-c72df1e start wdt-cus-hotspot-temp-01 elementor-widget elementor-widget-wdt-image-box"
                                          data-id="c72df1e"
                                          data-element_type="widget"
                                        >
                                          <div class="elementor-widget-container">
                                            <div
                                              class="wdt-image-box-holder wdt-content-item-holder wdt-column-holder wdt-rc-template-custom-template"
                                              id="wdt-image-box-c72df1e"
                                            >
                                              <div class="wdt-content-item">
                                                <div class="wdt-content-media-group">
                                                  <div class="wdt-content-image-wrapper">
                                                    <div class="wdt-content-image">
                                                      <Link
                                                        to="/shop"
                                                        rel="nofollow"
                                                      >
                                                        <img
                                                          width="600"
                                                          height="600"
                                                          src="https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-hotspot-img-04.png"
                                                          class="attachment-full size-full wp-image-2233"
                                                          alt=""
                                                          srcset="
                                    https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-hotspot-img-04.png         600w,
                                    https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-hotspot-img-04-300x300.png 300w,
                                    https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-hotspot-img-04-150x150.png 150w,
                                    https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-hotspot-img-04-100x100.png 100w,
                                    https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-hotspot-img-04-50x50.png    50w
                                  "
                                                          sizes="(max-width: 600px) 100vw, 600px"
                                                        />
                                                      </Link>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="wdt-content-detail-group">
                                                  <div class="wdt-content-title">
                                                    <h5>
                                                      <Link
                                                        to={"/shop"}
                                                        rel="nofollow"
                                                      >
                                                        Comfort Sofa
                                                      </Link>
                                                    </h5>
                                                  </div>
                                                  <div class="wdt-content-subtitle">
                                                    124 Products
                                                  </div>
                                                  <div class="wdt-content-description">
                                                    <p>
                                                      Discover stylish and comfortable sofas crafted to enhance your living space with modern design, premium quality, and lasting comfort.
                                                    </p>
                                                  </div>
                                                  <div class="wdt-content-button wdt-button-clone">
                                                    <Link
                                                      to={"/shop"}
                                                      rel="nofollow"
                                                    >
                                                      <div class="wdt-button-text">
                                                        <span> Shop Now</span>
                                                      </div>
                                                    </Link>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Hurry Banner  */}
          <section
            class="custom-slider-home-2  elementor-section elementor-top-section elementor-element elementor-element-bd5727b wdt-section-wrap-col elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="bd5727b"
            data-element_type="section"
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-960c714"
                data-id="960c714"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-5732a5b start center center elementor-widget__width-initial start before-title  elementor-widget elementor-widget-wdt-heading"
                    data-id="5732a5b"
                    data-element_type="widget"
                    data-widget_type="wdt-heading.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-heading-holder wdt-heading-wrapper-start"
                        id="wdt-heading-5732a5b"
                      >
                        <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span class="wdt-heading-subtitle">
                            <span class="wdt-heading-deco-inner wdt-left-part">
                              <span class="wdt-heading-deco-icon">
                                <span class="wdt-content-icon-wrapper">
                                  <span class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 100 100"
                                        >
                                          <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </span>
                                </span>
                              </span>{" "}
                            </span>
                            Shop Now & Save
                            <span class="wdt-heading-deco-inner wdt-right-part"></span>
                          </span>
                        </div>
                        <h2 class="wdt-heading-title-wrapper wdt-heading-align-center">
                          <span class="wdt-heading-title">
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">H</span>
                              <span class="wdt-split-heading-title">u</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">y</span>
                              <span class="wdt-split-heading-title">!</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">D</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">a</span>
                              <span class="wdt-split-heading-title">l</span>
                              <span class="wdt-split-heading-title">s</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">E</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">d</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">S</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">!</span>
                            </span>
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-5ef0b54 start center start  elementor-widget elementor-widget-wdt-button"
                    data-id="5ef0b54"
                    data-element_type="widget"
                    data-widget_type="wdt-button.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-button-holder wdt-template-filled wdt-button-link wdt-button-style-default wdt-button-size-nm wdt-animation- wdt-button-icon-after"
                        id="wdt-button-5ef0b54"
                      >
                        <Link class="wdt-button" to={bannerList?.path}>
                          <div class="wdt-button-text">
                            <span>Grab This Deals</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-8daf36a elementor-widget__width-initial elementor-widget-tablet_extra__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile elementor-hidden-tablet_extra  elementor-widget elementor-widget-image"
                    data-id="8daf36a"
                    data-element_type="widget"
                    data-widget_type="image.default"
                  >
                    <div class="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width="800"
                        height="500"
                        src={bannerList?.productImage}
                        class="attachment-full size-full wp-image-1684"
                        alt=""
                        sizes="(max-width: 800px) 100vw, 800px"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4bcc38d"
                data-id="4bcc38d"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-631e465 elementor-widget__width-auto wdt-cus-home-1-counter-style-01  elementor-widget elementor-widget-wdt-countdown"
                    data-id="631e465"
                    data-element_type="widget"
                    data-widget_type="wdt-countdown.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="wdt-countdown-holder">
                        <p class="wdt-countdown-label">
                          Hurry up! Deals end up :
                        </p>
                        <div
                          class="wdt-downcount"
                          data-date="10/10/2025 12:00:00"
                        >
                          <Countdown
                            date={moment(bannerList?.endTime).format(
                              "YYYY-MM-DDTHH:mm:ss"
                            )}
                            key={currentTime}
                            // date={moment(offerBanner?.endTime).format(
                            //   "YYYY-MM-DDTHH:mm:ss"
                            // )}
                            renderer={rendererOne}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Premium Collection */}
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-34047a9 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="34047a9"
            data-element_type="section"
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b4e612"
                data-id="7b4e612"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-37b2678 start center elementor-widget__width-initial elementor-widget-tablet__width-inherit before-title  elementor-widget elementor-widget-wdt-heading"
                    data-id="37b2678"
                    data-element_type="widget"
                    data-widget_type="wdt-heading.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-heading-holder wdt-heading-wrapper-start"
                        id="wdt-heading-37b2678"
                      >
                        <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span class="wdt-heading-subtitle">
                            <span class="wdt-heading-deco-inner wdt-left-part">
                              <span class="wdt-heading-deco-icon">
                                <span class="wdt-content-icon-wrapper">
                                  <span class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 100 100"
                                        >
                                          <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </span>
                                </span>
                              </span>{" "}
                            </span>
                            Premium Furnitures
                            <span class="wdt-heading-deco-inner wdt-right-part"></span>
                          </span>
                        </div>
                        <h2 class="wdt-heading-title-wrapper wdt-heading-align-center">
                          <span class="wdt-heading-title">
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">S</span>
                              <span class="wdt-split-heading-title">h</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">p</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">p</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">m</span>
                              <span class="wdt-split-heading-title">i</span>
                              <span class="wdt-split-heading-title">u</span>
                              <span class="wdt-split-heading-title">m</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">c</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">l</span>
                              <span class="wdt-split-heading-title">l</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">c</span>
                              <span class="wdt-split-heading-title">t</span>
                              <span class="wdt-split-heading-title">i</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">s</span>
                            </span>
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-676e58d end wdt-h1-product-filter-tab center  elementor-widget elementor-widget-wdt-tabs"
                    data-id="676e58d"
                    data-element_type="widget"
                    data-widget_type="wdt-tabs.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-tabs-container wdt-layout-horizontal wdt-template-default wdt-icon-style-inline wdt-icon-position-before-title"
                        data-class-items="wdt-layout-horizontal wdt-template-default wdt-icon-style-inline wdt-icon-position-before-title"
                      >
                        <div class="wdt-tabs-list-wrapper">
                          <ul
                            class="wdt-tabs-list ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
                            role="tablist"
                          >
                            <li
                              role="tab"
                              tabindex="0"
                              class={`ui-tabs-tab ui-corner-top ui-state-default ui-tab ${selectedCategory === "featuredProducts"
                                  ? " ui-tabs-active ui-state-active"
                                  : ""
                                }`}
                              aria-controls="wdt-tabs-0"
                              aria-labelledby="ui-id-1"
                              aria-selected="true"
                              aria-expanded="true"
                              onClick={() => {
                                setSelectedCategory("featuredProducts");
                              }}
                            >
                              <Link
                                to=""
                                tabindex="-1"
                                class="ui-tabs-anchor"
                                id="ui-id-1"
                              >
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-chair"
                                        viewBox="0 0 448 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                                <div class="wdt-content-title">
                                  Featured Products
                                </div>
                              </Link>
                            </li>
                            <li
                              role="tab"
                              tabindex="-1"
                              class={`ui-tabs-tab ui-corner-top ui-state-default ui-tab ${selectedCategory === "bestseller"
                                  ? " ui-tabs-active ui-state-active"
                                  : ""
                                }`}
                              aria-controls="wdt-tabs-1"
                              aria-labelledby="ui-id-2"
                              aria-selected="false"
                              aria-expanded="false"
                              onClick={() => {
                                setSelectedCategory("bestseller");
                              }}
                            >
                              <Link
                                to=""
                                tabindex="-1"
                                class="ui-tabs-anchor"
                                id="ui-id-2"
                              >
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-sort-amount-up"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                                <div class="wdt-content-title">
                                  Best Sellers
                                </div>
                              </Link>
                            </li>
                            <li
                              role="tab"
                              tabindex="-1"
                              class={`ui-tabs-tab ui-corner-top ui-state-default ui-tab ${selectedCategory === "topRated"
                                  ? " ui-tabs-active ui-state-active"
                                  : ""
                                }`}
                              aria-controls="wdt-tabs-2"
                              aria-labelledby="ui-id-3"
                              aria-selected="false"
                              aria-expanded="false"
                              onClick={() => {
                                setSelectedCategory("topRated");
                              }}
                            >
                              <Link
                                to=""
                                tabindex="-1"
                                class="ui-tabs-anchor"
                                id="ui-id-3"
                              >
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <svg
                                        aria-hidden="true"
                                        class="e-font-icon-svg e-fas-fire"
                                        viewBox="0 0 384 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                                <div class="wdt-content-title">
                                  Most Popular
                                </div>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div class="wdt-tabs-content-wrapper">
                          <div id="wdt-tabs-0" class="wdt-tabs-content">
                            <div
                              data-elementor-type="page"
                              data-elementor-id="573"
                              class="elementor elementor-573"
                            >
                              <section
                                class="elementor-section elementor-top-section elementor-element elementor-element-4dd089d elementor-section-full_width elementor-section-height-default elementor-section-height-default "
                                data-id="4dd089d"
                                data-element_type="section"
                              >
                                <div class="elementor-container elementor-column-gap-no">
                                  <div
                                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6d491aa"
                                    data-id="6d491aa"
                                    data-element_type="column"
                                  >
                                    <div class="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        class="elementor-element elementor-element-a793e17 elementor-widget elementor-widget-wdt-shop-products"
                                        data-id="a793e17"
                                        data-element_type="widget"
                                      >
                                        <div class="elementor-widget-container">
                                          <div class="wdt-products-container woocommerce wdt-products-carousel-a793e17">
                                            <ul class="products product-style-default product-hover-secimage-fade product-content-hover-slidebottom product-without-space product-padding-content wdt-cus-product-style-01 true product-label-boxed false product-thumb-alignment-bottom product-thumb-iconsgroup-position-horizontal horizontal-position-top-right product-thumb-iconsgroup-style-skinbrdrfill-rounded product-thumb-buttonelement-style-bgfill-square product-thumb-buttonelement-stretch product-content-alignment-center product-content-iconsgroup-style-simple product-content-buttonelement-style-simple column-4">
                                              <li class="product isotope-grid-sizer">
                                                <div class="wdt-col wdt-col-xs-12 wdt-col-sm-6 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-3 wdt-col-lg-3"></div>
                                              </li>
                                              {selectedCollection?.map(
                                                (item, i) => {
                                                  let dashedPrice =
                                                    item?.variants?.length > 0 && item?.variants.reduce(
                                                      (min, variant) =>
                                                        parseInt(
                                                          variant.price
                                                        ) < parseInt(min.price)
                                                          ? variant
                                                          : min
                                                    )?.price;
                                                  let originalPrice = "";
                                                  if (
                                                    item?.discountedPercentage
                                                  ) {
                                                    originalPrice = parseFloat(
                                                      parseFloat(dashedPrice) -
                                                      (dashedPrice *
                                                        item?.discountedPercentage) /
                                                      100
                                                    ).toFixed(2);
                                                  } else {
                                                    originalPrice = dashedPrice;
                                                  }
                                                  return (
                                                    <li
                                                      key={i}
                                                      class="blog-entry format-standard product-grid-view product type-product post-1631 status-publish first instock product_cat-wooden-chair product_tag-chair has-post-thumbnail sale shipping-taxable purchasable product-type-simple"
                                                    >
                                                      <div class="wdt-col wdt-col-xs-12 wdt-col-sm-6 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-3 wdt-col-lg-3">
                                                        <div class="product-wrapper">
                                                          <div class="product-thumb">
                                                            <Link
                                                              class="image"
                                                              to={`/product-details/${item?.id}`}
                                                              title="Solid Wood Chair"
                                                            >
                                                              <div class="product-thumb-overlay"></div>
                                                              {item?.label && (
                                                                <div class="product-labels">
                                                                  <span class="new">
                                                                    <span>
                                                                      {
                                                                        item?.label
                                                                      }
                                                                    </span>
                                                                  </span>
                                                                </div>
                                                              )}
                                                              <div class="primary-image">
                                                                <img
                                                                  decoding="async"
                                                                  src={
                                                                    JSON.parse(
                                                                      item?.productGallery ||
                                                                      "[]"
                                                                    )?.[0]
                                                                  }
                                                                  alt="Shop Primary Image"
                                                                  title="Shop Primary Image"
                                                                />
                                                              </div>
                                                            </Link>
                                                            <div class="product-thumb-content">
                                                              <div class="product-buttons-wrapper product-button">
                                                                <div class="wc_inline_buttons">
                                                                  <div
                                                                    class="wcct_btn_wrapper wc_btn_inline"
                                                                    data-tooltip="Add To Cart"
                                                                  >
                                                                    <Link
                                                                      onClick={() => {
                                                                        handleCartBtn(
                                                                          item
                                                                        );
                                                                      }}
                                                                      class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                                    >
                                                                      Add to
                                                                      cart
                                                                    </Link>
                                                                    <span
                                                                      id="woocommerce_loop_add_to_cart_link_describedby_1631"
                                                                      class="wdt-button too-small screen-reader-text"
                                                                    ></span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div class="product-element-group-wrapper">
                                                                <div class="product-element-group-items">
                                                                  <div class="product-buttons-wrapper product-icons">
                                                                    <div class="wc_inline_buttons">
                                                                      <div
                                                                        class="wcct_btn_wrapper wc_btn_inline"
                                                                        data-tooltip="Add To Cart"
                                                                      >
                                                                        <Link
                                                                          onClick={() => {
                                                                            handleCartBtn(
                                                                              item
                                                                            );
                                                                          }}
                                                                          class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                                        >
                                                                          Add to
                                                                          cart
                                                                        </Link>
                                                                        <span
                                                                          id="woocommerce_loop_add_to_cart_link_describedby_1631"
                                                                          class="wdt-button too-small screen-reader-text"
                                                                        ></span>
                                                                      </div>
                                                                      <div
                                                                        class="wcwl_btn_wrapper wc_btn_inline"
                                                                        data-tooltip="Wishlist"
                                                                      >
                                                                        <div
                                                                          class="tinv-wraper woocommerce tinv-wishlist tinvwl-shortcode-add-to-cart tinvwl-furniforma_woo_loop_product_button_elements_wishlist"
                                                                          data-tinvwl_product_id="1631"
                                                                        >
                                                                          <div class="tinv-wishlist-clear"></div>
                                                                          {wishList?.find(
                                                                            (
                                                                              er
                                                                            ) =>
                                                                              er
                                                                                ?.productDetails
                                                                                ?.id ===
                                                                              item?.id
                                                                          ) ? (
                                                                            <Link
                                                                              to="/wishlist"
                                                                              role="button"
                                                                              class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after  inited-add-wishlist tinvwl-product-in-list"
                                                                              tabindex="0"
                                                                            >
                                                                              <span class="tinvwl_add_to_wishlist-text">
                                                                                Go
                                                                                to
                                                                                Wishlist
                                                                              </span>
                                                                            </Link>
                                                                          ) : (
                                                                            <Link
                                                                              onClick={() => {
                                                                                handleWhishListBtn(
                                                                                  item
                                                                                );
                                                                              }}
                                                                              role="button"
                                                                              class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after"
                                                                              tabindex="0"
                                                                            >
                                                                              <span class="tinvwl_add_to_wishlist-text">
                                                                                Add
                                                                                to
                                                                                Wishlist
                                                                              </span>
                                                                            </Link>
                                                                          )}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="product-details">
                                                            <div class="product-title">
                                                              <h5>
                                                                <Link
                                                                  to={`/product-details/${item?.id}`}
                                                                >
                                                                  {
                                                                    item?.productName
                                                                  }
                                                                </Link>
                                                              </h5>
                                                            </div>
                                                            <div class="product-price">
                                                              <span class="price">
                                                                <span
                                                                  class="woocs_price_code"
                                                                  data-currency=""
                                                                  data-redraw-id="67ad7161b1e8e"
                                                                  data-product-id="1631"
                                                                >
                                                                  {item?.discountedPercentage && (
                                                                    <del aria-hidden="true">
                                                                      <span class="woocommerce-Price-amount amount">
                                                                        <bdi>
                                                                          <span class="woocommerce-Price-currencySymbol">
                                                                            &#8377;
                                                                          </span>
                                                                          &nbsp;
                                                                          {
                                                                            dashedPrice
                                                                          }
                                                                        </bdi>
                                                                      </span>
                                                                    </del>
                                                                  )}

                                                                  <ins aria-hidden="true">
                                                                    <span class="woocommerce-Price-amount amount">
                                                                      <bdi>
                                                                        <span class="woocommerce-Price-currencySymbol">
                                                                          &#8377;
                                                                        </span>
                                                                        &nbsp;
                                                                        {
                                                                          originalPrice
                                                                        }
                                                                      </bdi>
                                                                    </span>
                                                                  </ins>
                                                                </span>
                                                              </span>
                                                            </div>
                                                            <div class="product-rating-wrapper">
                                                              <div
                                                                class="star-rating"
                                                                role="img"
                                                                aria-label="Rated 4.00 out of 5"
                                                              >
                                                                <span
                                                                  style={{
                                                                    width: `${(+item
                                                                        ?.averageRatingsDetails?.[0]
                                                                        ?.averageRating /
                                                                        5) *
                                                                      100
                                                                      }%`,
                                                                  }}
                                                                >
                                                                  Rated
                                                                  <strong class="rating">
                                                                    {
                                                                      +item
                                                                        ?.averageRatingsDetails?.[0]
                                                                        ?.averageRating
                                                                    }
                                                                    .00
                                                                  </strong>
                                                                  out of 5
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Static Banner Section */}
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-c09594c elementor-section-full_width elementor-section-height-min-height elementor-section-items-top elementor-section-height-default"
            data-id="c09594c"
            data-element_type="section"
          >
            <div
              class="elementor-background-slideshow swiper swiper-fade swiper-initialized swiper-horizontal swiper-pointer-events swiper-rtl swiper-watch-progress swiper-backface-hidden"
              dir="rtl"
            >
              <Swiper
                effect={"fade"}
                grabCursor={false}
                fadeEffect={{ crossFade: true }} // Enables smooth fading effect   loop
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                speed={1000} // Increase speed for smooth transition
                modules={[Autoplay, EffectFade]}
                className="mySwiper elementor-background-slideshow swiper swiper-fade swiper-initialized swiper-horizontal swiper-pointer-events swiper-rtl swiper-watch-progress swiper-backface-hidden swiper-wrapper"
              >
                {advertiseBannerList?.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div
                      class="elementor-background-slideshow__slide__image swiper-lazy swiper-lazy-loaded"
                      style={{
                        backgroundImage: `url(${item?.advertiseImage})`,
                      }}
                    ></div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div class="elementor-background-overlay"></div>
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-07e6600"
                data-id="07e6600"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-8ef8f30 elementor-widget__width-initial = elementor-widget-mobile__width-inherit before-title center  elementor-widget elementor-widget-wdt-heading"
                    data-id="8ef8f30"
                    data-element_type="widget"
                    data-widget_type="wdt-heading.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-heading-holder wdt-heading-wrapper-center"
                        id="wdt-heading-8ef8f30"
                      >
                        <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span class="wdt-heading-subtitle">
                            <span class="wdt-heading-deco-inner wdt-left-part">
                              <span class="wdt-heading-deco-icon">
                                <span class="wdt-content-icon-wrapper">
                                  <span class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 100 100"
                                        >
                                          <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </span>
                                </span>
                              </span>{" "}
                            </span>
                            Our Stores
                            <span class="wdt-heading-deco-inner wdt-right-part"></span>
                          </span>
                        </div>
                        <h2 class="wdt-heading-title-wrapper wdt-heading-align-center">
                          <span class="wdt-heading-title">
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">T</span>
                              <span class="wdt-split-heading-title">h</span>
                              <span class="wdt-split-heading-title">e</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">S</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">f</span>
                              <span class="wdt-split-heading-title">a</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">Y</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">u</span>
                              <span class="wdt-split-heading-title">'</span>
                              <span class="wdt-split-heading-title">l</span>
                              <span class="wdt-split-heading-title">l</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">L</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">v</span>
                              <span class="wdt-split-heading-title">e</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">F</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">v</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">r</span>
                            </span>
                          </span>
                        </h2>
                        <div class="wdt-heading-content-wrapper">
                         Experience timeless comfort and elegant craftsmanship designed to elevate every living space with style, durability, and everyday relaxation.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-3403355 elementor-icon-list--layout-inline elementor-align-center wdt-cus-h1-iconlist-svg-bold elementor-list-item-link-inline  elementor-widget elementor-widget-icon-list"
                    data-id="3403355"
                    data-element_type="widget"
                  >
                    <div class="elementor-widget-container">
                      <ul class="elementor-icon-list-items elementor-inline-items">
                        <li class="elementor-icon-list-item elementor-inline-item">
                          <span class="elementor-icon-list-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 99.3 81.5"
                            >
                              <path d="M94.2,53.4V50a6.4,6.4,0,0,0-6.4-6.4H42.7A6.4,6.4,0,0,0,36.3,50v3.4a5.9,5.9,0,0,0-5.1,5.9V73a3.7,3.7,0,0,0,3.6,3.6h.5L35,78.1a2.3,2.3,0,0,0,.5,1.8,2.1,2.1,0,0,0,1.7.8H38a2.1,2.1,0,0,0,1.8-.9l2.3-3.2H88.5l2.2,3.2a2.3,2.3,0,0,0,1.9.9h.8a2.2,2.2,0,0,0,2.2-2.6l-.3-1.5h.4A3.6,3.6,0,0,0,99.3,73V59.3A5.9,5.9,0,0,0,94.2,53.4ZM38,50a4.5,4.5,0,0,1,1.4-3.3,4.7,4.7,0,0,1,3.3-1.4H87.8A4.8,4.8,0,0,1,92.6,50v3.4a5.9,5.9,0,0,0-5.1,5.9V63a4.4,4.4,0,0,0-2.7-.9H68.7a4.3,4.3,0,0,0-3.4,1.8,4.4,4.4,0,0,0-3.5-1.8H45.7a4.3,4.3,0,0,0-2.6.9V59.3A5.9,5.9,0,0,0,38,53.4ZM87.5,66.4v2.4H66.1V66.4a2.6,2.6,0,0,1,2.6-2.6H84.8a2.6,2.6,0,0,1,1.9.7A2.7,2.7,0,0,1,87.5,66.4Zm-23,0v2.4H43.1V66.4a2.6,2.6,0,0,1,2.6-2.6H61.8A2.6,2.6,0,0,1,64.5,66.4ZM38,79.1h-.8c-.2,0-.3-.1-.4-.3s-.2-.2-.2-.4l.4-1.8h3l-1.5,2.2C38.3,79,38.2,79.1,38,79.1Zm55.8-.3c-.1.2-.2.3-.4.3h-.8a.5.5,0,0,1-.5-.3l-1.5-2.2h3l.3,1.8C94,78.6,93.9,78.7,93.8,78.8Zm3.9-5.7a2,2,0,0,1-2,1.8H34.8A2,2,0,0,1,32.9,73V59.3a4.3,4.3,0,1,1,8.5,0V69.7a.9.9,0,0,0,.9.8h46a.9.9,0,0,0,.8-.8V59.3A4.3,4.3,0,0,1,93.4,55a4.3,4.3,0,0,1,4.3,4.3Z"></path>
                              <path d="M43.9,11.2A16,16,0,0,0,12.6,16V74.5H2.4A2.4,2.4,0,0,0,0,76.9v2.2a2.4,2.4,0,0,0,2.4,2.4H24.5a2.4,2.4,0,0,0,2.4-2.4V76.9a2.4,2.4,0,0,0-2.4-2.4H14.3V16a14.4,14.4,0,0,1,27.9-4.8A12.8,12.8,0,0,0,30.7,23.8a.8.8,0,0,0,.9.8h6.6a5.1,5.1,0,0,0,5.2,4,5,5,0,0,0,5.1-4h6.7a.7.7,0,0,0,.8-.8A12.7,12.7,0,0,0,43.9,11.2ZM25.2,76.8V79a.7.7,0,0,1-.7.7H2.4a.7.7,0,0,1-.7-.7V76.8a.8.8,0,0,1,.7-.7H24.5A1,1,0,0,1,25.2,76.8ZM43.3,27a3.4,3.4,0,0,1-3.4-2.3h6.8A3.6,3.6,0,0,1,43.3,27Zm-11-4a11,11,0,0,1,22,0Z"></path>
                              <path d="M35.9,27.1,32.7,29a.9.9,0,0,0-.3,1.2,1,1,0,0,0,.8.4h.4l3.2-1.9a.7.7,0,0,0,.2-1.1.9.9,0,0,0-1.1-.4Z"></path>
                              <path d="M43.3,31.1a.7.7,0,0,0-.8.8v3.7a.8.8,0,0,0,1.6,0V31.9A.9.9,0,0,0,43.3,31.1Z"></path>
                              <path d="M53.9,29.1l-3.2-1.9a.9.9,0,0,0-1.2.4.7.7,0,0,0,.3,1.1l3.3,1.9h.4a1,1,0,0,0,.8-.5c.1-.5.1-1-.4-1.1Z"></path>
                            </svg>
                          </span>
                          <span class="elementor-icon-list-text">
                            One stop shop
                          </span>
                        </li>
                        <li class="elementor-icon-list-item elementor-inline-item">
                          <span class="elementor-icon-list-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 99.3 81.5"
                            >
                              <path d="M91.1,8.6H22a3.6,3.6,0,0,0-.7-1,10.8,10.8,0,0,0-16.1,0A4.8,4.8,0,0,0,4,10.8V67.2h0v.3h0v.2a11.6,11.6,0,0,0,1.4,4.7v.2l.7.9a4.4,4.4,0,0,0,.9,1.1,10.5,10.5,0,0,0,7.3,3H90.1a5.2,5.2,0,0,0,5.2-5.2V13.7A5.2,5.2,0,0,0,91.1,8.6ZM5.8,10.8a3.5,3.5,0,0,1,.7-2.1,9.1,9.1,0,0,1,6.7-3,8.8,8.8,0,0,1,6.7,3,2.1,2.1,0,0,1,.6,1,3.6,3.6,0,0,1,.2,1.1V64.6l-.8-.6A11.8,11.8,0,0,0,17,62.4a13.2,13.2,0,0,0-3.9-.6H11.5l-.8.2a9.4,9.4,0,0,0-1.5.6l-.7.3-.3.2-.7.4-.9.7L6,65H5.9ZM93.5,72.4a3.4,3.4,0,0,1-3.4,3.4H14.5a8.4,8.4,0,0,1-6-2.5l-.8-.8a3.5,3.5,0,0,0-.5-.8h0L7,71.4l-.4-.8A9.4,9.4,0,0,1,6,67.8a.5.5,0,0,1,.2-.4l.4-.5c.2-.2.3-.4.5-.5l.5-.5.6-.5.4-.3.5-.2.9-.5h.1l1.4-.5,1.7-.3h2.3a8,8,0,0,1,4.2,2.3l.3.3.3.4v.2l.2.2.2.3a.9.9,0,0,0,1,.4.8.8,0,0,0,.7-.8V10.4H90.7a3.4,3.4,0,0,1,2.8,3.3Z"></path>
                              <path d="M82.6,33.7,55.4,21.4h-.8a.7.7,0,0,0-.4.6l-1.7,5.3L32.8,36.1a1,1,0,0,0-.5.8V51.6a1.1,1.1,0,0,0,.5.9L60.1,64.7h.7l21.8-9.8a.8.8,0,0,0,.5-.8V39.4a.9.9,0,0,0-.1-.5h-.3l-.7-.4,1.1-3.5A.8.8,0,0,0,82.6,33.7ZM61.3,62.5v-3l20-8.9v2.9Zm20-13.9-20,9V49.8L80.8,41l.5-.2ZM54.1,28.2l1.4-4.7L81.1,35l-1.4,4.5L65.9,45.7l-15-6.8Zm-20,9.3,17.8-8-2.7,9.1L34.1,45.4Zm25.4,25L34.1,51.1v-3L59.5,59.5ZM60,48.4a.8.8,0,0,0-.5.8v8.4L35.3,46.8l14.4-6.5,14.1,6.4Z"></path>
                            </svg>
                          </span>
                          <span class="elementor-icon-list-text">
                            3D Visualization
                          </span>
                        </li>
                        <li class="elementor-icon-list-item elementor-inline-item">
                          <span class="elementor-icon-list-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 99.3 81.5"
                            >
                              <path d="M3.5,78V65a14.1,14.1,0,0,1,28.2,0v3a.9.9,0,0,0,.3.7l.2.2L36,58.6a.8.8,0,0,1,.8-.7l13.5-1.2c.1-.1.3,0,.4,0a1,1,0,0,1,.6,1.3L46.4,71.2A6.2,6.2,0,0,1,47.7,75,6.3,6.3,0,0,1,46,79.2,6,6,0,0,1,41.7,81H6.6a3.4,3.4,0,0,1-2.2-.9A3.3,3.3,0,0,1,3.5,78ZM37.1,22.3a.9.9,0,0,1-1-1,1,1,0,0,1,1-1H54.2a1.1,1.1,0,0,1,1,1,1,1,0,0,1-1,1Zm0-3.3a1,1,0,0,1-1-1,1,1,0,0,1,1-1.1H54.2a1.1,1.1,0,0,1,1,1.1,1.1,1.1,0,0,1-1,1Zm0-3.4a1,1,0,0,1-1-1,.9.9,0,0,1,1-1H54.2a1,1,0,0,1,1,1,1.1,1.1,0,0,1-1,1Zm8-5.4a1,1,0,0,1,1,1,1.1,1.1,0,0,1-1,1h-8a1,1,0,0,1-1-1,.9.9,0,0,1,1-1ZM45.6.5A16,16,0,0,1,57,5.2a16.3,16.3,0,0,1,4.6,11.3,19.8,19.8,0,0,1-.3,3.5c-.3,1.1-.7,2.2-1.1,3.3a.6.6,0,0,0-.1.4l.2,4.3a4.3,4.3,0,0,1-.2,1.2,4.1,4.1,0,0,1-.7,1.1,4.1,4.1,0,0,1-1.1.7l-1.2.2L52.8,31h-.4l-3.3,1.1a19.8,19.8,0,0,1-3.5.3,16.3,16.3,0,0,1-11.3-4.6A16.1,16.1,0,0,1,45.6.5Zm9.9,6.1a14,14,0,0,0-9.9-4.1,14.3,14.3,0,0,0-9.9,4.1,14.3,14.3,0,0,0-4.1,9.9,14,14,0,0,0,14,14,14.5,14.5,0,0,0,3-.3,9.1,9.1,0,0,0,2.9-1l.7-.2h.7l4.3.2h.4l.3-.2.3-.4c0-.1.1-.2.1-.4l-.2-4.3c-.1-.2,0-.4,0-.6h0a2.5,2.5,0,0,1,.2-.7,13.3,13.3,0,0,0,1-2.8,15.5,15.5,0,0,0,.3-3.1,13.9,13.9,0,0,0-4.1-9.9Zm4.4,60.2V63.7a1,1,0,0,1,2,0v3.1H87.4V63.7a1,1,0,0,1,2,0v3.1h4.3a19.2,19.2,0,0,0-5.5-12.5,19.2,19.2,0,0,0-27.1,0,19.2,19.2,0,0,0-5.5,12.5ZM89.6,52.9a21.1,21.1,0,0,1,6.2,14.9,1,1,0,0,1-1,1H54.5a1,1,0,0,1-1-1A21.1,21.1,0,0,1,89.6,52.9ZM74.7,22.8a10.8,10.8,0,0,1,7.9,3.3,10.9,10.9,0,0,1,3.4,8,11.3,11.3,0,1,1-22.6,0A11.3,11.3,0,0,1,74.7,22.8Zm6.5,4.7a9.3,9.3,0,0,0-15.8,6.6,9,9,0,0,0,2.7,6.5,9.1,9.1,0,0,0,13.1,0,9.3,9.3,0,0,0,0-13.1ZM39,65a1,1,0,0,1,.5-1.3.9.9,0,0,1,1.3.4l2.7,5.2,1.2.5,4.2-11-11.2,1L34.3,69h6.8L39,65ZM24.5,28.2a11.3,11.3,0,1,1-8,19.3,11,11,0,0,1-3.3-8A11.3,11.3,0,0,1,24.5,28.2ZM31,32.9a9.6,9.6,0,0,0-6.5-2.7,9.6,9.6,0,0,0-6.6,2.7,9.3,9.3,0,1,0,13.1,0ZM5.5,65V78a2.1,2.1,0,0,0,.3.7,1.1,1.1,0,0,0,.8.3H41.7a4,4,0,0,0,2.8-1.2,3.9,3.9,0,0,0,0-5.6A4,4,0,0,0,41.7,71h-9a3.1,3.1,0,0,1-3-3V65a12.1,12.1,0,0,0-3.6-8.6,12.4,12.4,0,0,0-8.5-3.5,12.4,12.4,0,0,0-8.5,3.5A12.1,12.1,0,0,0,5.5,65Z"></path>
                            </svg>
                          </span>
                          <span class="elementor-icon-list-text">
                            Personalized Consulation
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-19da80a center  elementor-widget elementor-widget-wdt-button"
                    data-id="19da80a"
                    data-element_type="widget"
                    data-widget_type="wdt-button.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-button-holder wdt-template-filled wdt-button-link wdt-button-style-default wdt-button-size-nm wdt-animation- wdt-button-icon-after"
                        id="wdt-button-19da80a"
                      >
                        <Link class="wdt-button" to={"/contact-us"}>
                          <div class="wdt-button-text">
                            <span>View More Stores</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* slider 3 Home Decor */}
          {/* <section
            class="elementor-section elementor-top-section elementor-element elementor-element-3ba326b elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="3ba326b"
            data-element_type="section"
            data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6059937"
                data-id="6059937"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-6bb2803 start elementor-widget__width-auto elementor-widget-mobile_extra__width-inherit before-title  elementor-widget elementor-widget-wdt-heading"
                    data-id="6bb2803"
                    data-element_type="widget"
                    data-settings='{"item_align":"start","_animation":"fadeInUp","_animation_delay":200,"split_heading":"true","wdt_enable_inview_status":"true","header_decorative_elements_icon_align":"before-title","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                    data-widget_type="wdt-heading.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-heading-holder wdt-heading-wrapper-start"
                        id="wdt-heading-6bb2803"
                      >
                        <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span class="wdt-heading-subtitle">
                            <span class="wdt-heading-deco-inner wdt-left-part">
                              <span class="wdt-heading-deco-icon">
                                <span class="wdt-content-icon-wrapper">
                                  <span class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 100 100"
                                        >
                                          <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </span>
                                </span>
                              </span>{" "}
                            </span>
                            Home Decors furnitures
                            <span class="wdt-heading-deco-inner wdt-right-part"></span>
                          </span>
                        </div>
                        <h2 class="wdt-heading-title-wrapper wdt-heading-align-center">
                          <span class="wdt-heading-title">
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">H</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">m</span>
                              <span class="wdt-split-heading-title">e</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">F</span>
                              <span class="wdt-split-heading-title">u</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">i</span>
                              <span class="wdt-split-heading-title">t</span>
                              <span class="wdt-split-heading-title">u</span>
                              <span class="wdt-split-heading-title">r</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">s</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">C</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">l</span>
                              <span class="wdt-split-heading-title">l</span>
                              <span class="wdt-split-heading-title">e</span>
                              <span class="wdt-split-heading-title">c</span>
                              <span class="wdt-split-heading-title">t</span>
                              <span class="wdt-split-heading-title">i</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">s</span>
                            </span>
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-0449842 elementor-widget__width-auto start elementor-widget-tablet__width-inherit center  elementor-widget elementor-widget-wdt-button"
                    data-id="0449842"
                    data-element_type="widget"
                    data-settings='{"_animation":"fadeInUp","_animation_delay":300,"item_align_tablet":"start","item_align":"center","wdt_animation_effect":"none"}'
                    data-widget_type="wdt-button.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-button-holder wdt-template- wdt-button-link wdt-button-style-default wdt-button-size-nm wdt-animation- wdt-button-icon-after"
                        id="wdt-button-0449842"
                      >
                        <Link
                          class="wdt-button"
                          href="https://furniforma.wpengine.com/shop/"
                        >
                          <div class="wdt-button-text">
                            <span>View All Products</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-da89dfe  elementor-widget elementor-widget-wdt-shop-products"
                    data-id="da89dfe"
                    data-element_type="widget"
                    data-settings='{"carousel_slidesperview_tablet_extra":"3","_animation":"fadeInUp","_animation_delay":300,"carousel_slidesperview":4,"carousel_slidesperview_laptop":4,"carousel_slidesperview_tablet":2,"carousel_slidesperview_mobile_extra":1,"carousel_slidesperview_mobile":1,"wdt_animation_effect":"none"}'
                    data-widget_type="wdt-shop-products.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="wdt-products-carousel-container">
                        <div
                          class="wdt-products-container woocommerce swiper-container wdt-products-carousel-da89dfe"
                          data-carouseleffect=""
                          data-carouselslidespercolumn="2"
                          data-carouselloopmode=""
                          data-carouselslidesperview="4"
                          data-carouselmousewheelcontrol=""
                          data-carouselbulletpagination="true"
                          data-carouselarrowpagination=""
                          data-carouselscrollbar=""
                          data-carouselspacebetween="30"
                          data-carouselresponsive='{"slides_to_show":4,"responsive":[{"breakpoint":319,"toshow":1,"toscroll":1,"space_between":10},{"breakpoint":480,"toshow":1,"toscroll":1,"space_between":20},{"breakpoint":768,"toshow":2,"toscroll":1,"space_between":20},{"breakpoint":1025,"toshow":3,"toscroll":1,"space_between":20},{"breakpoint":1281,"toshow":4,"toscroll":1,"space_between":20},{"breakpoint":1541,"toshow":4,"toscroll":1,"space_between":30}]}'
                          data-id="da89dfe"
                        >
                          <Swiper
                            slidesPerView={4}
                            spaceBetween={20}
                            tag="ul"
                            loop
                            grabCursor={true}
                            autoplay={{
                              delay: 2500,
                              disableOnInteraction: false,
                            }}
                            modules={[Autoplay]}
                            className="mySwiper products swiper-wrapper"
                          >
                            {productsData.map((product) => (
                              <SwiperSlide
                                key={product.id}
                                tag="li"
                                className="swiper-slide"
                              >
                                <ul class="products swiper-wrapper product-style-default product-hover-secimage-fade product-content-hover-slidebottom product-without-space product-padding-content wdt-cus-product-style-02 true product-label-boxed thumb false product-thumb-alignment-bottom product-thumb-iconsgroup-style-simple product-thumb-buttonelement-style-bgfill-square product-thumb-buttonelement-stretch product-content-alignment-left product-content-iconsgroup-style-simple product-content-buttonelement-style-simple column-4">
                                  <li class="blog-entry format-standard product-grid-view swiper-slide product type-product post-1028 status-publish first instock product_cat-stylish-furniture product_tag-stylish-furniture has-post-thumbnail sale shipping-taxable purchasable product-type-simple">
                                    <div class="wdt-col wdt-col-xs-12 wdt-col-sm-6 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-3 wdt-col-lg-3">
                                      <div class="product-wrapper">
                                        <div class="product-thumb">
                                          <Link
                                            class="image"
                                            href="https://furniforma.wpengine.com/product/stylish-outdoor-sofa/"
                                            title="Stylish Outdoor Sofa"
                                          >
                                            <div class="product-thumb-overlay"></div>
                                            <div class="product-offers">
                                              <span class="product-saved-sale">
                                                <span>{product?.offer}%</span>{" "}
                                                off
                                              </span>
                                            </div>
                                            <div class="primary-image">
                                              <img
                                                decoding="async"
                                                src={product?.image}
                                                alt="Shop Primary Image"
                                                title="Shop Primary Image"
                                              />
                                            </div>
                                          </Link>
                                          <div class="product-thumb-content">
                                            <div class="product-buttons-wrapper product-button">
                                              <div class="wc_inline_buttons">
                                                <div
                                                  class="wcct_btn_wrapper wc_btn_inline"
                                                  data-tooltip="Add To Cart"
                                                >
                                                  <Link
                                                    class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                    href="?add-to-cart=1028"
                                                  >
                                                    Add to cart
                                                  </Link>
                                                  <span
                                                    id="woocommerce_loop_add_to_cart_link_describedby_1028"
                                                    class="wdt-button too-small screen-reader-text"
                                                  ></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="product-details">
                                          <div class="product-category-wrapper">
                                            <Link
                                              href="https://furniforma.wpengine.com/product-category/stylish-furniture/"
                                              rel="tag"
                                            >
                                              {product?.category}
                                            </Link>
                                          </div>
                                          <div class="product-element-group-wrapper">
                                            <div class="product-element-group-items">
                                              <div class="product-title">
                                                <h5>
                                                  <Link href="https://furniforma.wpengine.com/product/stylish-outdoor-sofa/">
                                                    {product?.title}
                                                  </Link>
                                                </h5>
                                              </div>
                                            </div>
                                            <div class="product-element-group-items">
                                              <div class="product-price">
                                                <span class="price">
                                                  <span
                                                    class="woocs_price_code"
                                                    data-currency=""
                                                    data-redraw-id="67ad7161edcc5"
                                                    data-product-id="1028"
                                                  >
                                                    <del aria-hidden="true">
                                                      <span class="woocommerce-Price-amount amount">
                                                        <bdi>
                                                          <span class="woocommerce-Price-currencySymbol">
                                                            &#8377;
                                                          </span>
                                                          &nbsp;
                                                          {product?.priceOld}
                                                        </bdi>
                                                      </span>
                                                    </del>
                                                    <span class="screen-reader-text">
                                                      Original price was:
                                                      &#036;&nbsp;
                                                      {product?.priceOld}.
                                                    </span>
                                                    <ins aria-hidden="true">
                                                      <span class="woocommerce-Price-amount amount">
                                                        <bdi>
                                                          <span class="woocommerce-Price-currencySymbol">
                                                            &#8377;
                                                          </span>
                                                          &nbsp;
                                                          {product?.priceNew}
                                                        </bdi>
                                                      </span>
                                                    </ins>
                                                    <span class="screen-reader-text">
                                                      Current price is:
                                                      &#036;&nbsp;
                                                      {product?.priceNew}.
                                                    </span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="tinv-wraper woocommerce tinv-wishlist tinvwl-after-add-to-cart tinvwl-loop-button-wrapper tinvwl-woocommerce_after_shop_loop_item"
                                          data-tinvwl_product_id="1028"
                                        >
                                          <div class="tinv-wishlist-clear"></div>
                                          <Link
                                            role="button"
                                            class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-position-after tinvwl-loop"
                                            tabindex="0"
                                          >
                                            <span class="tinvwl_add_to_wishlist-text">
                                              Add to Wishlist
                                            </span>
                                          </Link>
                                          <div class="tinv-wishlist-clear"></div>
                                          <div class="tinvwl-tooltip">
                                            Add to Wishlist
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          {/* Static Banner 2 */}

          {/* <section
            class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-694b4d6 elementor-reverse-tablet elementor-reverse-mobile_extra elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default "
            data-id="694b4d6"
            data-element_type="section"
          >
            <div class="elementor-background-overlay"></div>
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-96ee227"
                data-id="96ee227"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap"></div>
              </div>
              <div
                class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5a533a0"
                data-id="5a533a0"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-ca6ac2e start center center before-title elementor-widget elementor-widget-wdt-heading"
                    data-id="ca6ac2e"
                    data-element_type="widget"
                    data-widget_type="wdt-heading.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-heading-holder wdt-heading-wrapper-start"
                        id="wdt-heading-ca6ac2e"
                      >
                        <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span class="wdt-heading-subtitle">
                            <span class="wdt-heading-deco-inner wdt-left-part">
                              <span class="wdt-heading-deco-icon">
                                <span class="wdt-content-icon-wrapper">
                                  <span class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 100 100"
                                        >
                                          <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </span>
                                </span>
                              </span>{" "}
                            </span>
                            Style, Savings, Satisfaction
                            <span class="wdt-heading-deco-inner wdt-right-part"></span>
                          </span>
                        </div>
                        <h2 class="wdt-heading-title-wrapper wdt-heading-align-center">
                          <span class="wdt-heading-title">
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">E</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">j</span>
                              <span class="wdt-split-heading-title">o</span>
                              <span class="wdt-split-heading-title">
                                y
                              </span>{" "}
                            </span>
                            <span class="wdt-split-heading-wrapper wdt-heading-colored-elements">
                              <span class="wdt-split-heading-title">4</span>
                              <span class="wdt-split-heading-title">0</span>
                              <span class="wdt-split-heading-title">%</span>
                            </span>
                            <span class="wdt-split-heading-wrapper">
                              <span class="wdt-split-heading-title">S</span>
                              <span class="wdt-split-heading-title">a</span>
                              <span class="wdt-split-heading-title">v</span>
                              <span class="wdt-split-heading-title">i</span>
                              <span class="wdt-split-heading-title">n</span>
                              <span class="wdt-split-heading-title">g</span>
                              <span class="wdt-split-heading-title">s</span>
                            </span>
                          </span>
                        </h2>
                        <div class="wdt-heading-content-wrapper">
                          Accumsan montes nascetur tempor proin penatibus ligula
                          curae eu metus maximus fringilla primis finibus nunc
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-315b057 center elementor-widget elementor-widget-wdt-mailchimp"
                    data-id="315b057"
                    data-element_type="widget"
                    data-widget_type="wdt-mailchimp.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-mailchimp-holder wdt-template-type3"
                        id="wdt-mailchimp-315b057"
                      >
                        <div class="wdt-mailchimp-wrapper">
                          <form
                            class="wdt-mailchimp-subscribe-form with-btn-icon-and-text"
                            name="mailchimpSubscribeForm"
                            action="#"
                            method="post"
                          >
                            <input
                              type="email"
                              name="wdt_mc_emailid"
                              required="required"
                              placeholder="Email Address"
                              value=""
                            />
                            <input
                              type="hidden"
                              name="wdt_mc_apikey"
                              value=""
                            />
                            <input
                              type="hidden"
                              name="wdt_mc_listid"
                              value=""
                            />
                            <div class="wdt-mailchimp-subscription-button-holder">
                              <button type="submit" name="wdt_mc_submit">
                                <span>Subscribe</span>
                                <i>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 100"
                                    style={{
                                      enableBackground: "new 0 0 100 100",
                                    }}
                                  >
                                    <path d="M50,99C23,99,1,77.5,1,51.1v-2.2C1,22.5,23,1,50,1s49,21.5,49,47.9v2.2C99,77.5,77,99,50,99z M50,3.7 C24.5,3.7,3.8,24,3.8,48.9v2.2C3.8,76,24.5,96.3,50,96.3S96.2,76,96.2,51.1v-2.2C96.2,24,75.5,3.7,50,3.7z"></path>
                                    <polygon points="45.3,71 43.3,69.1 62.8,50 43.3,30.9 45.3,29 66.8,50 "></polygon>
                                  </svg>
                                </i>
                              </button>
                            </div>
                          </form>
                          <div class="wdt-mailchimp-subscription-msg"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-286b62a wdt-cus-terms-and-consition-label-h1 elementor-widget elementor-widget-text-editor"
                    data-id="286b62a"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div class="elementor-widget-container">
                      <p>
                        *By Submitting this form, you agree to receive
                        Furiforma&#8217;s email newsletter  and promotional
                        offers.
                        <Link href="https://furniforma.wpengine.com/terms-and-conditions/">
                          Terms and Condition
                        </Link>
                        Apply.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          {/* logo Slider  */}

          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-a2017ec elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="a2017ec"
            data-element_type="section"
            data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ec973c2"
                data-id="ec973c2"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-36dc46f wdt-cus-brand-logo-style-01  elementor-widget elementor-widget-wdt-animation"
                    data-id="36dc46f"
                    data-element_type="widget"
                    data-settings='{"_animation":"fadeInUp","_animation_delay":200,"wdt_mqa_direction":"left-to-right","wdt_animation_effect":"none"}'
                    data-widget_type="wdt-animation.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-animation-holder "
                        id="wdt-animation-36dc46f"
                        data-settings='{"direction":"left-to-right"}'
                      >
                        <div class="wdt-animation-wrapper">
                          <div class="wdt-animation-main-marqee custom-logo-slider left-to-right">
                            {brandLogo.map((logo) => (
                              <div class="wdt-animation-item icon-item">
                                <img src={logo?.brandLogo} alt="logo" />
                              </div>
                            ))}
                          </div>
                          <div class="wdt-animation-cloned-marqee">
                            {brandLogo.map((logo) => (
                              <div class="wdt-animation-item icon-item">
                                <img src={logo?.brandLogo} alt="logo" />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* static Banner -2  */}
          <Testimonials />
          {/* static Banner 3 */}
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-cfbef9b elementor-section-full_width elementor-section-height-default elementor-section-height-default "
            data-id="cfbef9b"
            data-element_type="section"
          >
            <div class="elementor-container elementor-column-gap-no">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c5f1523"
                data-id="c5f1523"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-27f3505 start wdt-cus-home-1-iconbox-style-01 center center elementor-widget elementor-widget-wdt-icon-box"
                    data-id="27f3505"
                    data-element_type="widget"
                    data-widget_type="wdt-icon-box.default"
                  >
                    <div class="elementor-widget-container">
                      <div
                        class="wdt-icon-box-holder wdt-content-item-holder wdt-column-holder wdt-rc-template-custom-template"
                        id="wdt-icon-box-27f3505"
                      >
                        <div
                          class="wdt-column-wrapper wdt-column-gap-custom wdt-snap-scroll-enabled"
                          data-column-settings='{"columnDevices":["laptop","tablet_extra","tablet","mobile_extra","mobile"]}'
                          data-module-id="wdt-module-id-27f3505"
                          id="wdt-module-id-27f3505"
                        >
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 50 50"
                                        >
                                          <path d="M49.82,11.93,45.91,4a.84.84,0,0,0-.72-.46H39.66V.82a.86.86,0,0,0-.24-.57A.83.83,0,0,0,38.85,0H10.32a.81.81,0,0,0-.57.23.85.85,0,0,0-.23.57V3.58H17.2a1.3,1.3,0,0,1,.89.37,1.25,1.25,0,0,1,.36.89,1.29,1.29,0,0,1-.36.89,1.34,1.34,0,0,1-.89.36H6.85A1.15,1.15,0,0,1,6.2,5.9a1,1,0,0,0-.32.52.89.89,0,0,0,0,.6,1,1,0,0,0,.36.47,1,1,0,0,0,.58.18H9.52v.85h4.77a1.17,1.17,0,0,1,.87.36,1.23,1.23,0,0,1,0,1.78,1.21,1.21,0,0,1-.87.36H3.92a1.14,1.14,0,0,1-.64-.19,1,1,0,0,0-.32.51.94.94,0,0,0,0,.6,1,1,0,0,0,.37.48,1,1,0,0,0,.57.18H9.51v.84h1.85a1.25,1.25,0,0,1,1.25,1.26A1.25,1.25,0,0,1,11.36,16H1a1.28,1.28,0,0,1-.65-.18,1,1,0,0,0-.32.51,1,1,0,0,0,0,.6,1,1,0,0,0,.37.47,1,1,0,0,0,.57.19H9.51v3.63a.79.79,0,0,0,.81.8H12.5a4.86,4.86,0,0,1,9.71,0h15.1A4.85,4.85,0,1,1,47,22h2.17a.8.8,0,0,0,.82-.8V12.66A1.58,1.58,0,0,0,49.82,11.93Zm-2.15.57a.47.47,0,0,1-.15.13.31.31,0,0,1-.19.06H40.46a.86.86,0,0,1-.57-.24.83.83,0,0,1-.23-.57V6.3a.81.81,0,0,1,.23-.57.86.86,0,0,1,.57-.24h3.46a.79.79,0,0,1,.42.12.86.86,0,0,1,.3.33l3,6.16a.46.46,0,0,1,0,.2A.66.66,0,0,1,47.67,12.5Z"></path>
                                          <path d="M45.51,22a3.36,3.36,0,0,1-2.07,3.1,3.27,3.27,0,0,1-1.93.19,3.37,3.37,0,0,1-1.72-.92,3.45,3.45,0,0,1-.92-1.71,3.38,3.38,0,0,1,.2-1.94,3.29,3.29,0,0,1,1.23-1.5,3.34,3.34,0,0,1,1.86-.57A3.36,3.36,0,0,1,45.51,22Z"></path>
                                          <path d="M20.7,22a3.42,3.42,0,0,1-.56,1.87,3.38,3.38,0,0,1-1.51,1.23A3.35,3.35,0,0,1,15,24.34a3.22,3.22,0,0,1-.91-1.71,3.38,3.38,0,0,1,.18-1.94,3.33,3.33,0,0,1,1.25-1.5,3.27,3.27,0,0,1,1.86-.57,3.39,3.39,0,0,1,2.36,1A3.32,3.32,0,0,1,20.7,22Z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-title">
                                  <h5>Door Delivery</h5>
                                </div>
                                <div class="wdt-content-description">
                                  <p>
                                    Habitasse ad nisi duis praesent nullam
                                    habitasse
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 50 50"
                                        >
                                          <path d="M46.39,10.13l-6,5.48L42.47,34a1,1,0,0,1-.06.48,1.12,1.12,0,0,1-.25.42l-1.62,1.61a1,1,0,0,1-.44.27,1.18,1.18,0,0,1-.53,0,1.05,1.05,0,0,1-.47-.21,1.07,1.07,0,0,1-.32-.41l-6.1-13.59-9.62,8.72.52,5.45a1.24,1.24,0,0,1-.06.47,1.07,1.07,0,0,1-.26.4l-1.09,1.1a1.14,1.14,0,0,1-.93.31,1.14,1.14,0,0,1-.46-.18,1.09,1.09,0,0,1-.34-.37l-3.2-5.77-5.77-3.21a1,1,0,0,1-.37-.33,1,1,0,0,1-.18-.47,1,1,0,0,1,0-.49,1.24,1.24,0,0,1,.26-.43l1.1-1.1a1.12,1.12,0,0,1,.4-.25,1,1,0,0,1,.48-.06l5.45.51,8.71-9.62L13.78,11.22a1.07,1.07,0,0,1-.41-.32,1,1,0,0,1-.21-.48,1.15,1.15,0,0,1,0-.52,1,1,0,0,1,.27-.45l1.61-1.61a1.14,1.14,0,0,1,.42-.26,1.11,1.11,0,0,1,.48,0l18.42,2.1,5.48-6C43.48,0,46.44-.86,49.15.85,50.86,3.56,50,6.52,46.39,10.13Z"></path>
                                          <path d="M15.05,17.51a.93.93,0,0,1-.27.65L1.56,31.38a1,1,0,0,1-.29.2.84.84,0,0,1-.35.07,1.13,1.13,0,0,1-.36-.06,1,1,0,0,1-.29-.2.83.83,0,0,1-.2-.3A.84.84,0,0,1,0,30.74a1,1,0,0,1,.07-.35,1,1,0,0,1,.21-.3L13.5,16.87a.91.91,0,0,1,1.55.64Z"></path>
                                          <path d="M33.4,35.86a.84.84,0,0,1-.07.35,1,1,0,0,1-.2.29L19.91,49.72a.83.83,0,0,1-.3.2.85.85,0,0,1-.35.08,1,1,0,0,1-.35-.07,1,1,0,0,1-.3-.2.88.88,0,0,1-.19-1,.84.84,0,0,1,.2-.29L31.84,35.22a1,1,0,0,1,.3-.21,1,1,0,0,1,.35-.07.84.84,0,0,1,.35.07.83.83,0,0,1,.3.2,1,1,0,0,1,.2.29A.91.91,0,0,1,33.4,35.86Z"></path>
                                          <path d="M16.48,40.52a.89.89,0,0,1-.25.64L10.9,46.49a.81.81,0,0,1-.3.21,1,1,0,0,1-.35.07.84.84,0,0,1-.35-.07.83.83,0,0,1-.3-.2.77.77,0,0,1-.19-.3.91.91,0,0,1,0-.7,1,1,0,0,1,.2-.29l5.33-5.33a.9.9,0,0,1,.64-.26.91.91,0,0,1,.64.27A.89.89,0,0,1,16.48,40.52Z"></path>
                                          <path d="M10.38,34.41a.91.91,0,0,1-.27.64L4.78,40.38a1,1,0,0,1-.29.2.84.84,0,0,1-.35.07.83.83,0,0,1-.35-.06,1,1,0,0,1-.3-.2,1,1,0,0,1-.2-.3.84.84,0,0,1-.07-.35.85.85,0,0,1,.08-.35.83.83,0,0,1,.2-.3l5.33-5.32a.89.89,0,0,1,1.28,0A.89.89,0,0,1,10.38,34.41Z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-title">
                                  <h5>Free Shipping</h5>
                                </div>
                                <div class="wdt-content-description">
                                  <p>
                                    Praesent idligula a diam hendrerit interdum
                                    quisnon .
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 50 50"
                                        >
                                          <path d="M35,24.65a3.52,3.52,0,0,1,7,0v3h3v-3a6.5,6.5,0,0,0-13,0v3h3Z"></path>
                                          <path d="M47,29.44H30.12a1.23,1.23,0,0,0-1.22,1.22V43a1.23,1.23,0,0,0,1.22,1.22H47a1.23,1.23,0,0,0,.87-.36,1.25,1.25,0,0,0,.35-.86V30.66a1.25,1.25,0,0,0-.35-.86A1.23,1.23,0,0,0,47,29.44ZM40,38.3a1.47,1.47,0,0,1-.43,1.05,1.48,1.48,0,0,1-2.11,0,1.51,1.51,0,0,1-.43-1.05v-3a1.49,1.49,0,0,1,1.49-1.49,1.49,1.49,0,0,1,1,.44,1.47,1.47,0,0,1,.43,1Z"></path>
                                          <path d="M45.49,5.81h-41A4.47,4.47,0,0,0,0,10.26V36.88a4.47,4.47,0,0,0,4.51,4.44H25.7a.89.89,0,0,0,.63-.26.89.89,0,0,0,0-1.26.89.89,0,0,0-.63-.26H4.51a2.7,2.7,0,0,1-2.72-2.66V17H48.21v9.74a.9.9,0,0,0,.27.63.86.86,0,0,0,.63.26.89.89,0,0,0,.89-.89V10.26a4.47,4.47,0,0,0-4.51-4.45ZM1.79,12.39V10.26a2.71,2.71,0,0,1,.81-1.9,2.75,2.75,0,0,1,1.91-.77h41a2.75,2.75,0,0,1,1.91.77,2.71,2.71,0,0,1,.81,1.9v2.13Z"></path>
                                          <path d="M6.89,34.34a.89.89,0,0,0-.89.89.86.86,0,0,0,.26.63.88.88,0,0,0,.63.26h3a.86.86,0,0,0,.63-.26.87.87,0,0,0,.27-.63.89.89,0,0,0-.27-.63.86.86,0,0,0-.63-.26Z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-title">
                                  <h5>Secure Payments</h5>
                                </div>
                                <div class="wdt-content-description">
                                  <p>
                                    Donec ac purus non libero vulputa teultr
                                    ices uisque .
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 50 50"
                                        >
                                          <path d="M7.79,37.56H9.15A3.62,3.62,0,0,0,12.76,34V25.69a3.62,3.62,0,0,0-3.6-3.61H5a.87.87,0,0,0-.86.86V34A3.68,3.68,0,0,0,5.24,36.5a3.61,3.61,0,0,0,2.55,1.06"></path>
                                          <path d="M45,22.08H40.84a3.6,3.6,0,0,0-3.6,3.61V34a3.6,3.6,0,0,0,3.6,3.61h1.37a3.82,3.82,0,0,0,.89-.12L31.32,48.29h-3.4V47.1a.85.85,0,0,0-.86-.86H22.93a.85.85,0,0,0-.85.86v2a.85.85,0,0,0,.85.85h8.72a.82.82,0,0,0,.58-.23L45.54,37.51a.69.69,0,0,0,.2-.28.85.85,0,0,0,.08-.35v-14a.83.83,0,0,0-.26-.6.84.84,0,0,0-.6-.25"></path>
                                          <path d="M36.61,8.74a21.54,21.54,0,0,1,7,11.61l0,.2a.81.81,0,0,0,.33.5.87.87,0,0,0,.59.14.82.82,0,0,0,.53-.28.86.86,0,0,0,.21-.56,20.35,20.35,0,1,0-40.7,0,.85.85,0,0,0,.21.56.83.83,0,0,0,.53.27A.8.8,0,0,0,6,21a.85.85,0,0,0,.34-.49l.05-.2a21.42,21.42,0,0,1,7-11.61,18.21,18.21,0,0,1,23.22,0Z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-title">
                                  <h5>24x7 Support</h5>
                                </div>
                                <div class="wdt-content-description">
                                  <p>
                                    Felis hendrerit aliquet. Quisque justo , ac
                                    ligula.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column">
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-icon-wrapper">
                                  <div class="wdt-content-icon">
                                    <span>
                                      <i>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 39.3 49.7"
                                        >
                                          <path d="M33.8,11.1,20.3,5.8a1.3,1.3,0,0,0-1.2,0L5.5,11.1a1.5,1.5,0,0,0-1,1.5V25c0,7.9,7.3,14.5,14.1,18.7a2,2,0,0,0,2.1,0C27.6,39.5,34.8,32.9,34.8,25V12.6a1.5,1.5,0,0,0-1-1.5ZM32.8,25a13.7,13.7,0,0,1-3.3,8.5,34.5,34.5,0,0,1-9.4,8.2c-.4.3-.4.3-.9,0a37.7,37.7,0,0,1-9.4-8.2A14.3,14.3,0,0,1,6.5,25V13.1l.3-.4L19.5,7.8h.3l12.8,5c.1,0,.2.2.2.3ZM7.3,13.4V25a13.5,13.5,0,0,0,3.1,8,36.9,36.9,0,0,0,9.3,8.1A34.8,34.8,0,0,0,28.9,33,12.9,12.9,0,0,0,32,25V13.4L19.7,8.6Zm20.8,3.7a1.6,1.6,0,0,1,0,2.3l-10.6,10a1.5,1.5,0,0,1-1.2.5,2.3,2.3,0,0,1-1.2-.6l-4-5.1a1.6,1.6,0,1,1,2.6-2l2.9,3.6L25.8,17a1.6,1.6,0,0,1,2.3.1Z"></path>
                                        </svg>
                                      </i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-title">
                                  <h5>Trusted Partners</h5>
                                </div>
                                <div class="wdt-content-description">
                                  <p>
                                    Vestibulum augue nibh, eget ante nec,
                                    viverra leo.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {loginModal && <Login open={loginModal} setOpen={setLoginModal} referralCode={referralCode}/>}
    </div>
  );
};

export const rendererOne = ({ days, hours, minutes, seconds }) => (
  <>
    <div class="wdt-counter-wrapper">
      <div class="wdt-counter-inner-wrapper">
        <div class="wdt-counter-icon-wrapper">
          <div class="wdt-counter-number days">{days}</div>
        </div>
        <h3 class="title">Days</h3>
      </div>
      <span class="wdt-counter-divider">:</span>
    </div>
    <div class="wdt-counter-wrapper">
      <div class="wdt-counter-inner-wrapper">
        <div class="wdt-counter-icon-wrapper">
          <div class="wdt-counter-number hours">{hours}</div>
        </div>
        <h3 class="title">Hrs</h3>
      </div>
      <span class="wdt-counter-divider">:</span>
    </div>
    <div class="wdt-counter-wrapper">
      <div class="wdt-counter-inner-wrapper">
        <div class="wdt-counter-icon-wrapper">
          <div class="wdt-counter-number minutes">{minutes}</div>
        </div>
        <h3 class="title">Mins</h3>
      </div>
      <span class="wdt-counter-divider">:</span>
    </div>
    <div class="wdt-counter-wrapper last">
      <div class="wdt-counter-inner-wrapper">
        <div class="wdt-counter-icon-wrapper">
          <div class="wdt-counter-number seconds">{seconds}</div>
        </div>
        <h3 class="title">Secs</h3>
      </div>
    </div>
  </>
);

export default Home;
